import { NavLink } from 'react-router';
import {
  LayoutDashboard,
  Users,
  Clock,
  DollarSign,
  FileText,
  Upload,
  Settings,
  LogOut,
} from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/customers', icon: Users, label: 'Customers' },
  { to: '/entries', icon: Clock, label: 'Time Entries' },
  { to: '/charges', icon: DollarSign, label: 'Charges' },
  { to: '/import', icon: Upload, label: 'Import CSV' },
  { to: '/invoices', icon: FileText, label: 'Invoices' },
];

export function Sidebar() {
  const { logout } = useAuth();

  return (
    <aside className="w-64 glass flex flex-col h-screen sticky top-0">
      {/* Logo */}
      <div className="p-6 border-b border-white/10 dark:border-gray-700/30">
        <h1 className="text-2xl font-bold bg-gradient-to-r from-primary-500 to-primary-700 dark:from-primary-400 dark:to-primary-600 bg-clip-text text-transparent">
          Invoicer
        </h1>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto scrollbar-thin">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'sidebar-item-active' : ''}`
            }
            end={item.to === '/'}
          >
            <item.icon className="w-5 h-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Bottom section */}
      <div className="p-4 border-t border-white/10 dark:border-gray-700/30 space-y-1">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `sidebar-item ${isActive ? 'sidebar-item-active' : ''}`
          }
        >
          <Settings className="w-5 h-5" />
          <span>Settings</span>
        </NavLink>

        <button
          onClick={() => logout()}
          className="sidebar-item w-full text-left text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300"
        >
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
